import type {IntBoolean} from '@myparcel/sdk';
import type {Shipment} from '@myparcel-frontend/types';
import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useShipmentStore = defineStore('shipments', () => {
  const shipments = ref<Shipment[]>([]);
  const results = ref(0);

  const setShipments = (data: {shipments: Shipment[]; results: number}) => {
    shipments.value = data.shipments;
    results.value = data.results;
  };

  const getShipmentById = (id: number): Shipment | undefined => shipments.value.find((shipment) => shipment.id === id);

  const setShipmentHidden = (id: number, hidden: IntBoolean) => {
    const shipment = getShipmentById(id);

    if (shipment) {
      shipment.hidden = hidden;
    }
  };

  const setDeliveryNotificationEmail = (id: number, email: string | string[]) => {
    const shipment = getShipmentById(id);

    if (shipment) {
      const emails = Array.isArray(email) ? email : [email];
      shipment.general_settings.delivery_notification_email = emails;
    }
  };

  return {
    shipments,
    results,
    setShipments,
    getShipmentById,
    setShipmentHidden,
    setDeliveryNotificationEmail,
  };
});
